import React from "react";
import PropTypes from "prop-types";

import withStyles from '@mui/styles/withStyles';

import QualificationComponent from './QualificationComponent';
import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import QualificationAccordionSummary from './QualificationAccordionSummary';

import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';

import QualificationTextField from 'components/Shared/QualificationTextField';

import MyDatePicker from 'components/Shared/MyDatePicker';

const styles = theme => ({
    row: {
        flexBasis: '100%',
        marginBottom: '10px'
    },

    formControl: {
        margin: theme.spacing(1)
    },

    group: {
        margin: theme.spacing(1, 0)
    },
    heightLabel: {
        height: '30px'
    },
});



class SavByFoussierExtensionGarantie extends QualificationComponent {


    constructor(props) {
        super(props);

        this.state = {
            ...this.state,

            [ReclamationQualificationDetailCodes.SavByFoussierGarantieEtendue]: '',
            [ReclamationQualificationDetailCodes.SavByFoussierDateFinExtensionGarantie]: new Date(this.props.dateFinExtensionGarantie),
            [ReclamationQualificationDetailCodes.SavByFoussierCodeExtensionGarantie]: ''
        };

        this.generableCodes = [
            ReclamationQualificationDetailCodes.SavByFoussierGarantieEtendue,
            ReclamationQualificationDetailCodes.SavByFoussierDateFinExtensionGarantie,
            ReclamationQualificationDetailCodes.SavByFoussierCodeExtensionGarantie
        ];
    }





    componentDidMount() {
        const { name } = this.props;
        const { position, toAdd, toDelete } = this.getQualificationData(this.state);

        this.props.onChange(name, position, toAdd, toDelete, "Mount");

    }



    componentDidUpdate(prevProps) {

        const { name } = this.props;

        if (prevProps.dateFinExtensionGarantie !== this.props.dateFinExtensionGarantie) {

            let newState = {
                ...this.state,
                [ReclamationQualificationDetailCodes.SavByFoussierDateFinExtensionGarantie]: new Date(this.props.dateFinExtensionGarantie),
            };


            this.setState(newState);

            const { position, toAdd, toDelete } = this.getQualificationData(newState);

            this.props.onChange(name, position, toAdd, toDelete, "Mount");

        }
    }
    getQualificationData(newState) {

        // Préparation des codes à supprimer (tous les codes générables)
        let toDelete = [...this.generableCodes];

        if (    (newState[ReclamationQualificationDetailCodes.SavByFoussierGarantieEtendue] === '')
            ||
                (newState[ReclamationQualificationDetailCodes.SavByFoussierGarantieEtendue] === '1' && (
                   !newState[ReclamationQualificationDetailCodes.SavByFoussierDateFinExtensionGarantie])
            )

        ) {
            return {
                name: newState.name,
                position: this.props.position,
                toAdd: null,
                toDelete: toDelete
            };
        }



        let toAdd = [];

        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.SavByFoussierGarantieEtendue,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: "L'article fait-il partie d'une extension de garantie ?",
            valeurBool: newState[ReclamationQualificationDetailCodes.SavByFoussierGarantieEtendue] === '1'
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SavByFoussierGarantieEtendue);

        if (newState[ReclamationQualificationDetailCodes.SavByFoussierGarantieEtendue] === '1') {

            toAdd.push({
                position: 0,
                code: ReclamationQualificationDetailCodes.SavByFoussierDateFinExtensionGarantie,
                type: ReclamationQualificationDetailType.Date,
                libelle: "Date de fin d'extension de garantie",
                valeurDate: newState[ReclamationQualificationDetailCodes.SavByFoussierDateFinExtensionGarantie],

            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SavByFoussierDateFinExtensionGarantie);

            toAdd.push({
                position: 0,
                code: ReclamationQualificationDetailCodes.SavByFoussierCodeExtensionGarantie,
                type: ReclamationQualificationDetailType.Texte,
                libelle: "Code extension de garantie",
                valeurString: newState[ReclamationQualificationDetailCodes.SavByFoussierCodeExtensionGarantie],

            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SavByFoussierCodeExtensionGarantie);

        }




        return {
            name: newState.name,
            position: this.props.position,
            toAdd: toAdd,
            toDelete: toDelete
        }
    }


    render() {
        const { name } = this.props;

        return (


            <Accordion id={name} defaultExpanded={true} elevation={3}>

                <QualificationAccordionSummary title="Extension de garantie" />

                <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>


                    <FormControl required>
                        <FormLabel>{"L'article fait-il partie d'une extension de garantie ?"}</FormLabel>
                        <RadioGroup
                            name={ReclamationQualificationDetailCodes.SavByFoussierGarantieEtendue}
                            value={this.state[ReclamationQualificationDetailCodes.SavByFoussierGarantieEtendue]}
                            onChange={this.handleChange}
                        >
                            <FormControlLabel value='1' control={<Radio />} label={"Oui"} />


                            {this.state[ReclamationQualificationDetailCodes.SavByFoussierGarantieEtendue] === '1' &&

                                <div style={{ marginLeft: '42px' }}>
                                    <QualificationTextField
                                        label={"Code extension de garantie"}
                                        name={ReclamationQualificationDetailCodes.SavByFoussierCodeExtensionGarantie}
                                        value={this.state[ReclamationQualificationDetailCodes.SavByFoussierCodeExtensionGarantie]}
                                        onChange={this.handleChange}
                                    />

                                    <MyDatePicker
                                        label="Date de fin d'extension de garantie"
                                        value={this.state[ReclamationQualificationDetailCodes.SavByFoussierDateFinExtensionGarantie]}
                                    onChange={value => this.handleChange({ target: { name: ReclamationQualificationDetailCodes.SavByFoussierDateFinExtensionGarantie, value: value } })}
                                        required                                    
                                    />

                                </div>
                            }




                            <FormControlLabel value='0' control={<Radio />} label={"Non"} />
                        </RadioGroup>
                    </FormControl>



                </AccordionDetails>
            </Accordion>



        );
    }

}


SavByFoussierExtensionGarantie.propTypes = {
    name: PropTypes.string.isRequired
};

//SavByFoussierExtensionGarantie.defaultProps = {
//};

export default withStyles(styles)(SavByFoussierExtensionGarantie);